import React from "react";
import { Truck, ExternalLink } from "lucide-react";
import { carrierLabel, shortDate } from "../lib/shipping";

export default function PackageList({ order }) {
  const shipments = order.shipments || [];
  if (!shipments.length) return null;
  return (
    <div className="space-y-3" data-testid={`package-list-${order.id}`}>
      <p className="eyebrow">{shipments.length === 1 ? "Your package" : `Your ${shipments.length} packages`}</p>
      {shipments.map((s, i) => (
        <div
          key={s.id}
          className="bg-[var(--bg-cream)] border border-[var(--border)] rounded-xl p-4 flex flex-wrap items-center gap-4"
          data-testid={`package-${s.id}`}
        >
          <span className="w-10 h-10 rounded-full bg-[var(--terracotta)]/10 flex items-center justify-center shrink-0">
            <Truck className="w-4 h-4 text-[var(--terracotta)]" />
          </span>
          <div className="flex-1 min-w-[180px]">
            <p className="text-sm text-[var(--ink-forest)] font-medium">
              {shipments.length > 1 ? `Package ${i + 1} · ` : ""}{carrierLabel(s)}
              <span className="text-[var(--muted-fg)] font-normal"> · sent {shortDate(s.created_at)}</span>
            </p>
            {s.tracking_number && (
              <p className="font-mono text-xs text-[var(--ink-forest)] mt-0.5" data-testid={`package-number-${s.id}`}>{s.tracking_number}</p>
            )}
            <p className="text-xs text-[var(--muted-fg)] mt-1">
              {[
                ...(s.item_indices || []).map((idx) => order.items[idx]?.name),
                ...(s.swap_ids || []).map((sid) => (order.swaps || []).find((w) => w.id === sid)?.name),
              ].filter(Boolean).join(", ")}
            </p>
          </div>
          {s.tracking_url && (
            <a
              href={s.tracking_url}
              target="_blank"
              rel="noreferrer"
              className="bg-[var(--terracotta)] text-white rounded-full px-4 py-2 text-xs font-semibold hover:bg-[var(--terracotta-deep)] transition-colors inline-flex items-center gap-1.5"
              data-testid={`package-track-link-${s.id}`}
            >
              Track package <ExternalLink className="w-3 h-3" />
            </a>
          )}
        </div>
      ))}
    </div>
  );
}
